import { Vue, Component } from 'vue-property-decorator'
import DashboardViewsHeaderArea from '@/modules/dashboard-module/views/header-area/dashboard-views-header-area.vue'
import DashboardViewsUtilitiesArea from '@/modules/dashboard-module/views/utilities-area/dashboard-views-utilities-area.vue'
import DashboardViewsAnalyticArea from '@/modules/dashboard-module/views/analytic-area/dashboard-views-analytic-area.vue'
import { uiComponentCustomConfigService } from '@/api/services/common/ui-component/custom-config/ui-component-custom-config.service'
import { dashboardModuleLayoutWidgets } from '@/modules/dashboard-module/shared/models/dashboard-widgets'
import { store } from '@/store/store'
import { dashboardStore } from '@/modules/dashboard-module/store/dashboard.store'
import { DashboardModuleLayoutWidget, DashboardModuleLayoutWidgetRenderComponent, DashboardModuleSection, DashboardModuleUIComponentState, DashboardModuleWidgetOption } from '@/modules/dashboard-module/shared/models/dashboard-module.model'
import { dashboardModuleGetUIComponent, hasSectionAccess } from '@/modules/dashboard-module/shared/models/dashboard-module.helpers'
import { HelperUtils } from '@/shared/util/helper-utils'
import { PortionOperation } from '@/api/operations/models/portion-operation'
import { SubportionOperation } from '@/api/operations/models/subportion-operation'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { CaseOperation } from '@/api/operations/models/case-operation'

@Component({
    components: {
        DashboardViewsHeaderArea,
        DashboardViewsAnalyticArea,
        DashboardViewsUtilitiesArea
    }
})
export default class DashboardModule extends Vue {
    beforeCreate(): void {
        dashboardStore.register()
    }
    beforeDestroy(): void {
        dashboardStore.unregister()
    }

    async mounted(): Promise<void> {
        await this._initAllAllowedWidgets()
        await this._loadUIComponent()
    }

    private async _initAllAllowedWidgets(): Promise<void> {
        const filterWidgetsByAccess = dashboardModuleLayoutWidgets().filter((widget: DashboardModuleLayoutWidget) => {
            if (widget.section === DashboardModuleSection.LABORATORY) {
                return hasSectionAccess(widget.section) && DashboardModule._getFilterCategoriesLaboratory(widget)
            }
            if (widget.section === DashboardModuleSection.REGISTRY) {
                if (widget.renderComponent === DashboardModuleLayoutWidgetRenderComponent.NEW_CASE_WIDGET) {
                    return hasSectionAccess(widget.section) && HelperUtils.hasLabOperation(store.getters.labId, CaseOperation.CREATE)
                }
            }
            return hasSectionAccess(widget.section)
        })
        await store.dispatch('dashboard/setAllWidgets', filterWidgetsByAccess)
    }

    private async _loadUIComponent(): Promise<void> {
        const response = await PromiseUtils.toCallSecure(uiComponentCustomConfigService.get<DashboardModuleUIComponentState>(dashboardModuleGetUIComponent().name, store.getters.labId), () => { return true })
        if (response) {
            await store.dispatch('dashboard/setIdUIComponent', response.id)
            if (response.config.pendingArea.length) {
                response.config.pendingArea.forEach(async (widget) => {
                    await store.dispatch('dashboard/addWidgetAndSetVisible', widget)
                })
            }
            if (response.config.chartArea.length) {
                response.config.chartArea.forEach(async (widget) => {
                    await store.dispatch('dashboard/addWidgetAndSetVisible', widget)
                })
            }
            if (response.config.interestingDataArea.length) {
                response.config.interestingDataArea.forEach(async (widget) => {
                    await store.dispatch('dashboard/addWidgetAndSetVisible', widget)
                })
            }
            if (response.config.utilitiesArea.length) {
                response.config.utilitiesArea.forEach(async (widget) => {
                    await store.dispatch('dashboard/addWidgetAndSetVisible', widget)
                })
            }
        }
    }

    private static _getFilterCategoriesLaboratory(laboratoryFilteredWidgets: DashboardModuleLayoutWidget): boolean {
        switch (laboratoryFilteredWidgets.widgetOption) {
        case DashboardModuleWidgetOption.PORTION_MAKE:
            return HelperUtils.hasOperationInCurrentLaboratory(PortionOperation.MAKE)
        case DashboardModuleWidgetOption.PORTION_CUT:
            return HelperUtils.hasOperationInCurrentLaboratory(PortionOperation.CUT)
        case DashboardModuleWidgetOption.SUBPORTION_TO_SCANNER:
            return HelperUtils.hasOperationInCurrentLaboratory(SubportionOperation.TO_SCANNER)
        case DashboardModuleWidgetOption.SUBPORTION_SCAN:
            return HelperUtils.hasOperationInCurrentLaboratory(SubportionOperation.SCAN)
        default:
            return true
        }
    }
}
